import { render, staticRenderFns } from "./UploadEntity.vue?vue&type=template&id=0d6efa4b&"
import script from "./UploadEntity.vue?vue&type=script&lang=js&"
export * from "./UploadEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UploadEntity.vue"
export default component.exports